import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const orderRoutes: RouteRecordRaw[] = [
  {
    path: '/orders',
    name: 'orders',
    component: () => import('@/modules/orders/views/OrderListView.vue'),
    meta: {
      permission: PERMISSIONS.ESHOP.ORDERS,
      projectScoped: true,
    },
  },
  {
    path: '/orders/:id/detail',
    redirect: (to) => ({
      path: '/orders',
      query: { detail: to.params.id as string },
    }),
  },
]
